import { useEffect, useRef, useState } from 'react';
import { CheckIcon, CopyIcon } from 'lucide-react';
import { toast } from 'sonner';
import { btnGhost } from '../ui/styles';

/** Zo lang staat "Gekopieerd" in beeld. */
const CONFIRM_MS = 1600;

/** Kopieert tekst naar het klembord, met een korte bevestiging. */
export function CopyButton({
  text,
  label = 'Kopieer'
}: {
  text: string;
  label?: string;
}) {
  const [done, setDone] = useState(false);
  const timer = useRef<number>();

  // Timer opruimen als de knop verdwijnt (bijv. bij wisselen van ontwerp).
  useEffect(() => () => window.clearTimeout(timer.current), []);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setDone(true);
      window.clearTimeout(timer.current);
      timer.current = window.setTimeout(() => setDone(false), CONFIRM_MS);
    } catch {
      setDone(false);
      toast.error('Kopiëren lukte niet', {
        description: 'Selecteer de tekst en kopieer hem zelf.'
      });
    }
  };
  return <button type="button" onClick={copy} className={btnGhost} aria-live="polite" data-id="element-2850" data-mp="1fwhmjxe1qub8">
      {done ? <CheckIcon className="h-4 w-4 text-sage" strokeWidth={2} aria-hidden="true" data-id="element-2851" data-mp="1axehicy2go39" /> : <CopyIcon className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" data-id="element-2852" data-mp="1punmwak7fsdz" />}
      {done ? 'Gekopieerd' : label}
    </button>;
}